/**
 * 简易的Storage工具
 * @type {Storage}
 */


const sessionStorage = window.sessionStorage;
const localStorage = window.localStorage;



function createStorage(storage) {
  return {
    /**
     * @param key
     * @param value
     * @param original  是否原样保存
     */
    set(key, value, original = false) {
      if (value == void 0) {
        this.remove(key);
        return;
      }
      if (original) {
        storage.setItem(key, value);
      } else {
        storage.setItem(key, JSON.stringify({
          __dsfStorageValue: value
        }));
      }
    },
    /**
     * @param key
     * @param defaultValue  默认值
     * @param original      是否原样返回
     */
    get(key, defaultValue = null, original = false) {
      let value = storage.getItem(key);
      if (dsf.isUnDef(value)) {
        return defaultValue;
      }
      if (original || value.indexOf('__dsfStorageValue') == -1) {
        return value;
      }
      try {
        value = JSON.parse(value);
      } catch (e) {
        return value;
      }
      if (dsf.type(value) == 'object' && _.keys(value).indexOf('__dsfStorageValue') > -1) {
        return value.__dsfStorageValue;
      }
      return defaultValue;
    },
    remove(key) {
      storage.removeItem(key);
    },
    clear() {
      storage.clear();
    },
    /**
     * @param key
     * @returns {boolean}
     */
    has(key) {
      let value = storage.getItem(key);
      return !dsf.isUnDef(value);

    },
    length() {
      return storage.length;
    }
  }
}


export default {
  session: createStorage(sessionStorage),
  local: createStorage(localStorage)
}